import { render, staticRenderFns } from "./PageTab.vue?vue&type=template&id=bca63544&scoped=true&"
import script from "./PageTab.vue?vue&type=script&lang=js&"
export * from "./PageTab.vue?vue&type=script&lang=js&"
import style0 from "./PageTab.vue?vue&type=style&index=0&id=bca63544&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca63544",
  null
  
)

export default component.exports